import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { authFetch } from '../../utils/api';
import StudentViewContext from '../../contexts/StudentViewContext';

export function StudentViewProvider({ children }) {
  const { user, token } = useAuth();
  const [viewingStudent, setViewingStudent] = useState(null);
  const [myStudents, setMyStudents] = useState([]);

  useEffect(() => {
    if (user && token) {
      authFetch('/api/user/training-team', token).then(d => {
        setMyStudents((d.students || []).filter(s => s.status === 'active'));
      }).catch(() => {});
    } else {
      setMyStudents([]); setViewingStudent(null);
    }
  }, [user, token]);

  const switchToStudent = (student) => setViewingStudent(student);
  const clearStudent = () => setViewingStudent(null);

  return (
    <StudentViewContext.Provider value={{ viewingStudent, setViewingStudent: switchToStudent, clearStudent, myStudents }}>
      {children}
    </StudentViewContext.Provider>
  );
}
